export default {
	navbar: {
		document: 'SDK使用教程',
		joshvm: 'JoshVM开放文档',
		developer: 'JOSH Cloud使用指南',
		community: 'JOSH开发者社区',
	},
	docMenu: {
		base: '快速入门',
		start: '基础教程',
		startItem: {
			init: '搭建开发环境',
			develop: '使用流程',
			debug: '调试方法'
		},
		demo: '功能示例',
		demoItem: {
			socket: 'Socket',
			gpio: 'GPIO',
			uart: 'Uart',
			file: 'File',
			deviceInfo: 'DeviceInfo'
		},
		device: 'JOSH 开发板',
		deviceItem: {
			'2G': 'MEGA 8300',
			'2G1': '硬件说明',
			'2G2': '操作手册',
			'esp': 'MEGA ESP32',
			'esp1': '硬件说明',
			'esp2': '操作手册'
		},
		otherDevice: '第三方开发板',
		otherDeviceItem: {
			'wroverkit': 'ESP-WROVER-KIT',
			'wroverkit1': '固件更新',
			'wroverkit2': '应用开发',
			'mini': 'ESP-LyraT-Mini',
			'mini1': '固件更新',
			'mini2': '应用开发'
		},
		resource: '资源下载',
		api: 'API文档',
		resourceItem: {
			ide: '开发工具',
			device: '开发板',
			demo: '示例中心'
		}
	},
	devMenu: {
		introduce: '平台介绍',
		regist: '加入平台',
		registItem: {
			develop: '成为开发者'
		},
		device: '设备管理',
		deviceItem: {
			device: '设备',
			group: '分组',
			task: '任务'
		},
		app: '应用管理',
		user: '个人账户',
		overview: '监测/概览'
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh.js